<div class="row mb-5">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row no-gutters p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">#</span>
                </div>
                <div class="col-md-8 col-12 text-start">
                    <span class="text-white align-self-center">Libellé</span>
                </div>
                <div class="col-md-3 col-12">
                    <span class="text-white align-self-center text-center">Statut</span>
                </div>
            </div>
              
            <div class="mb-3" style="height: 65vh; overflow-y: scroll; overflow-x: hidden; ">
                <table class="table">
                    <tr class="p-0" *ngFor="let d of data; let i=index">
                        <td class="">
                                {{i+1}}
                        </td>
                        <td class="w-75 text-start">
                                    <span class="text-dark h6"><strong><small>{{d.sac?.student?.lastname}} {{d.sac?.student?.firstname}}</small></strong></span>
                   
                        </td>
                        <td class="d-flex flex-column" >
                                <h6 class="fw-bold" style="font-size: 12px;">{{d.type}}</h6>
                               <ng-container *ngIf="d.type == 'Retard'">
                                   <span  style="font-size: 12px;"> {{d.coming_time | date:"dd-MM-yyyy hh:mm:ss"}}</span>
                                </ng-container>    
                                <ng-container *ngIf="d.type != 'Présent' && d.motif!= ''">
                                    <p class="p-0" class="fw-bold" style="font-size: 12px;">{{d.motif}}</p>
                                    <div *ngIf="d.motif_filename != null" (click)="getFile2(data?.code+'/'+d.motif_filename)" class="text-primary"><u>Voir le fichier</u></div>
                                </ng-container>   
                        </td>
                    </tr>
                </table>
                
            </div>

        </div>
    </div>
</div>